import type { HandleUpload } from '@payloadcms/plugin-cloud-storage/types'
import type { CollectionConfig } from 'payload'

type Args = {
    collection: CollectionConfig
    prefix?: string
}

const multipartThreshold = 1024 * 1024 * 50 // 50MB
export const getHandleUpload = ({}: Args): HandleUpload => {
    return async ({ data, file }) => {
        // ! We do not implement the server side upload for now as wlodev solely use client uploads
        return data
    }
}
